import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-validated-datetime-picker',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './validated-datetime-picker.component.html',
  styleUrl: './validated-datetime-picker.component.scss',
})
export class ValidatedDateTimePickerComponent {
  label = input.required<string>();
  inputFormControlName = input.required<string>();
  inputFormControl = input.required<FormControl<string | Date | null>>();
  validationTranslations = input<Record<string, string>>();
  leaveSpaceForValidation = input<boolean>(false);

  private to2Digits = (number: number) =>
    number < 10 ? `0${number}` : `${number}`;

  presetMidnight = (ev: Event): void => {
    const el = ev.target as HTMLInputElement | null;
    if (!el) return;

    if (!el.value) {
      const date = new Date();
      const yyyy = date.getFullYear();
      const mm = this.to2Digits(date.getMonth() + 1);
      const dd = this.to2Digits(date.getDate());
      const value = `${yyyy}-${mm}-${dd}T00:00`;

      el.value = value;
      this.inputFormControl().patchValue(value, { emitEvent: true });
    }
  };

  hasRequiredValidator(): boolean {
    return this.inputFormControl().hasValidator(Validators.required);
  }
  errorKeys(): string[] {
    const control = this.inputFormControl();
    return control.errors ? Object.keys(control.errors) : [];
  }
  getErrorMessage(key: string): string {
    return this.validationTranslations()?.[key] ?? key;
  }
}
